import React from 'react'

import { formField } from 'decorators'

import DateRangePicker from './DateRangePicker'

export default formField(props => <DateRangePicker {...props} />)
